import React from 'react';

export const CheckMarkSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6835_5647)">
          <path d="M31.5873 1.22293C30.3122 0.421156 28.6099 0.773156 27.784 2.00871L12.3748 25.0407L4.86001 18.3029C3.74442 17.3029 2.00551 17.3687 0.974256 18.4505C-0.056994 19.5314 0.0108393 21.2194 1.12642 22.2185L10.9934 31.0647C10.9934 31.0647 11.2767 31.3012 11.4078 31.3838C11.8698 31.6754 12.3886 31.814 12.9019 31.814C13.8021 31.814 14.6848 31.3856 15.2119 30.598L32.3976 4.91093C33.2244 3.67538 32.8614 2.02382 31.5873 1.22293Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_6835_5647">
            <rect width="33" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>

    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6835_5644)">
        <path d="M31.5873 1.22293C30.3122 0.421156 28.6099 0.773156 27.784 2.00871L12.3748 25.0407L4.86001 18.3029C3.74442 17.3029 2.00551 17.3687 0.974256 18.4505C-0.056994 19.5314 0.0108393 21.2194 1.12642 22.2185L10.9934 31.0647C10.9934 31.0647 11.2767 31.3012 11.4078 31.3838C11.8698 31.6754 12.3886 31.814 12.9019 31.814C13.8021 31.814 14.6848 31.3856 15.2119 30.598L32.3976 4.91093C33.2244 3.67538 32.8614 2.02382 31.5873 1.22293Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_6835_5644">
          <rect width="33" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}